export const es = {
    logout: `Cerrar sesión`,
    changePassword: `Cambiar contraseña`,
    editProfile: `Editar perfil`,
    theme: `Tema`,
    language: `Idioma`,
};
//# sourceMappingURL=es.js.map